
export const Arrowup = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" color="blue" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
    </svg>)
}

export const HorizontalArrow = ({ position,
    left,
    bottom,
    top,
    height }) => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 30.2 831" style={{
                enableBackground: "new 0 0 30.2 831", position: position,
                left: left,
                bottom: bottom,
                top: top,
                height: height
            }}>
            <g>
                <g>
                    <line stroke="#000000" strokeWidth="3" strokeMiterlimit="10" x1="-1563.8" y1="-64.5" x2="-740" y2="-64.5" />
                    <g>
                        <path d="M-1543.3-50.1c0.4-0.7,0.2-1.6-0.5-2.1l-19.4-12.3l19.4-12.3c0.7-0.4,0.9-1.4,0.5-2.1c-0.4-0.7-1.4-0.9-2.1-0.5
				l-21.3,13.6c-0.4,0.3-0.7,0.8-0.7,1.3s0.3,1,0.7,1.3l21.3,13.6c0.2,0.2,0.5,0.2,0.8,0.2C-1544.1-49.4-1543.6-49.7-1543.3-50.1z"
                        />
                    </g>
                    <g>
                        <path d="M-760.5-50.1c-0.4-0.7-0.2-1.6,0.5-2.1l19.4-12.3l-19.4-12.3c-0.7-0.4-0.9-1.4-0.5-2.1c0.4-0.7,1.4-0.9,2.1-0.5
				l21.3,13.6c0.4,0.3,0.7,0.8,0.7,1.3s-0.3,1-0.7,1.3l-21.3,13.6c-0.2,0.2-0.5,0.2-0.8,0.2C-759.7-49.4-760.2-49.7-760.5-50.1z"/>
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <line stroke="#000000" strokeWidth="3" strokeMiterlimit="10" x1="15.1" y1="3.6" x2="15.1" y2="827.4" />
                    <g>
                        <path d="M0.7,24.1c0.7,0.4,1.6,0.2,2.1-0.5L15.1,4.3l12.3,19.4c0.4,0.7,1.4,0.9,2.1,0.5c0.7-0.4,0.9-1.4,0.5-2.1L16.4,0.7
				C16.1,0.3,15.6,0,15.1,0s-1,0.3-1.3,0.7L0.2,22C0.1,22.3,0,22.6,0,22.8C0,23.3,0.2,23.8,0.7,24.1z"/>
                    </g>
                    <g>
                        <path d="M0.7,806.9c0.7-0.4,1.6-0.2,2.1,0.5l12.3,19.4l12.3-19.4c0.4-0.7,1.4-0.9,2.1-0.5s0.9,1.4,0.5,2.1l-13.6,21.3
				c-0.3,0.4-0.8,0.7-1.3,0.7s-1-0.3-1.3-0.7L0.2,809c-0.2-0.2-0.2-0.5-0.2-0.8C0,807.7,0.2,807.2,0.7,806.9z"/>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export const VerticalArrow = ({ position,
    left,
    bottom,
    right,
    width }) => {
    return (<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        viewBox="0 0 831 30.2" style={{
            enableBackground: "new 0 0 831 30.2", position: position,
            left: left,
            bottom: bottom,
            right: right,
            width: width
        }}>
        <style type="text/css">

        </style>
        <g>
            <g>
                <line className="st0" fill="none" stroke="#000000" strokeWidth="3" strokeMiterlimit="10" x1="3.6" y1="15.1" x2="827.4" y2="15.1" />
                <g>
                    <path d="M24.1,29.5c0.4-0.7,0.2-1.6-0.5-2.1L4.3,15.1L23.6,2.8c0.7-0.4,0.9-1.4,0.5-2.1C23.7,0,22.7-0.2,22,0.2L0.7,13.8
               C0.3,14.1,0,14.6,0,15.1s0.3,1,0.7,1.3L22,30c0.2,0.2,0.5,0.2,0.8,0.2C23.3,30.2,23.8,29.9,24.1,29.5z"/>
                </g>
                <g>
                    <path d="M806.9,29.5c-0.4-0.7-0.2-1.6,0.5-2.1l19.4-12.3L807.4,2.8c-0.7-0.4-0.9-1.4-0.5-2.1c0.4-0.7,1.4-0.9,2.1-0.5l21.3,13.6
               c0.4,0.3,0.7,0.8,0.7,1.3s-0.3,1-0.7,1.3L809,30c-0.2,0.2-0.5,0.2-0.8,0.2C807.7,30.2,807.2,29.9,806.9,29.5z"/>
                </g>
            </g>
        </g>
        <g>
            <g>
                <line className="st0" x1="1582.5" y1="83.2" x2="1582.5" y2="907" />
                <g>
                    <path d="M1568.1,103.7c0.7,0.4,1.6,0.2,2.1-0.5l12.3-19.4l12.3,19.4c0.4,0.7,1.4,0.9,2.1,0.5c0.7-0.4,0.9-1.4,0.5-2.1l-13.6-21.3
               c-0.3-0.4-0.8-0.7-1.3-0.7s-1,0.3-1.3,0.7l-13.6,21.3c-0.2,0.2-0.2,0.5-0.2,0.8C1567.4,102.9,1567.7,103.4,1568.1,103.7z"/>
                </g>
                <g>
                    <path d="M1568.1,886.5c0.7-0.4,1.6-0.2,2.1,0.5l12.3,19.4l12.3-19.4c0.4-0.7,1.4-0.9,2.1-0.5s0.9,1.4,0.5,2.1l-13.6,21.3
               c-0.3,0.4-0.8,0.7-1.3,0.7s-1-0.3-1.3-0.7l-13.6-21.3c-0.2-0.2-0.2-0.5-0.2-0.8C1567.4,887.3,1567.7,886.8,1568.1,886.5z"/>
                </g>
            </g>
        </g>
    </svg>
    )
}